import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GooglePlacesAutoComplete from '../../misc/GooglePlacesAutoComplete';

function City(props) {
    const [profile, setProfile] = useState(props.user.user.profile),
        [city, setCity] = useState(props.user.user.profile.city || ''),
        { addToFilledItems,
            removeFromFilledItems } = props;
    useEffect(() => {
        setProfile(props.user.user.profile);
    }, [props.user.user.profile]);
    useEffect(() => {
        if (props.user.user.profile.city) {
            addToFilledItems('city', {
                'city': city
            })
        }
    }, []);
    return (<div className="profile-edit-modal__form__group">
        <label className="form-label">Current City</label>
        <GooglePlacesAutoComplete
            className="form-input form-input--secondary"
            searchOptions={{types: ['(cities)']}}
            handleLocationChange={(city) => {
                setCity(city.split(',')[0])
                if (city) {
                    addToFilledItems('city', {
                        'city': city.split(',')[0]
                    })
                } else {
                    removeFromFilledItems('city')
                }
            }}
            suggestionContainerClassName="collaboration-form__suggestion__container"
            suggestionClassName="collaboration-form__suggestion"
            location={city} />
    </div>)
};

function mapStateToProps(state) {
    return {
        user: state.user
    }
}

City.propTypes = {
    addToFilledItems: PropTypes.func,
    removeFromFilledItems: PropTypes.func
}

export default connect(mapStateToProps)(City);